/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BabylonGeneralInfo } from '../models/BabylonGeneralInfo';
import type { BabylonGeneralSummaryInfo } from '../models/BabylonGeneralSummaryInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class BabylonGeneralControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns BabylonGeneralInfo OK
     * @throws ApiError
     */
    public getBabylonGeneral({
        types,
    }: {
        types: string,
    }): CancelablePromise<BabylonGeneralInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/general',
            query: {
                'types': types,
            },
        });
    }

    /**
     * @returns BabylonGeneralSummaryInfo OK
     * @throws ApiError
     */
    public getBabylonGeneralSummary(): CancelablePromise<BabylonGeneralSummaryInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/general/summary',
        });
    }

}
